import React from 'react';
import { Formik } from 'formik';
import {
    TextField,
    withStyles,
    Button,
    CircularProgress,
    Typography
} from '@material-ui/core';
import * as Yup from 'yup';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    rootEdit: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submit: {
        width: '100%',
        marginTop: '10px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    next: {
        width: '120px',
        marginTop: '10px',
        marginRight: '10px'
    },
    formControl: {
        width: '100%'
    },

    datePicker: {
        width: '100%'
    }
});

const PrePaidPlanForm = props => {
    const {
        classes,
        formSettings,
        initialValues,
        handleSubmit,
        translations,
        loading,
    } = props;

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                await handleSubmit(values);
            }}
            validationSchema={Yup.object().shape(formSettings.Validation)}
        >
            {formikProps => {
                const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;

                return (
                    <div className={classes.root}>
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["name"] || 'Name'}
                                label={translations["name"] || 'Name'}
                                margin={'dense'}
                                fullWidth={true}
                            />
                            <TextField
                                name="Credit"
                                value={values.Credit}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Credit && touched.Credit)}
                                placeholder={translations["credit"] || 'Credit'}
                                label={translations["credit"] || 'Credit'}
                                margin={'dense'}
                                fullWidth={true}
                                type="number"
                            />
                            <Button
                                className={classes.submit}
                                variant="contained"
                                color={formSettings.ButtonSubmit.Color}
                                type="submit"
                                disabled={loading || !(isValid && dirty) || isSubmitting}
                            >
                                {isSubmitting ? (
                                    <CircularProgress size={24} />
                                ) : (
                                        formSettings.ButtonSubmit.Title
                                    )}
                            </Button>
                        </form>
                    </div>
                );
            }}
        </Formik>
    );
};

export default withStyles(styles, { withTheme: true })(PrePaidPlanForm);
